export default {
      id: "logo-usage",
      viewBox: "0 0 229.258 166.516",
      url: "../../assets/" + "sprite.svg#logo-usage",
      toString: function () {
        return this.url;
      }
    }